<template>
  <div class="promo-materials-carousel">
    <h5 v-if="!lightTitle" class="mb-6">{{ title }}</h5>
    <h6 v-else class="mb-6 light-text">{{ title }}</h6>

    <carousel
      :per-page-custom="perPageCustom"
      :navigation-enabled="true"
      :paginationEnabled="false"
      navigation-next-label="<i class='icon-angle-right'></i>"
      navigation-prev-label="<i class='icon-angle-left'></i>"
    >
      <slide v-for="item in items" :key="item.id" class="px-3 py-5">
        <promo-material :title="item.name" :description="item.description" />
      </slide>
    </carousel>
  </div>
</template>

<script>
import PromoMaterial from "@/components/marketplace/PromoMaterial";
export default {
  components: {
    PromoMaterial
  },
  props: {
    title: {
      type: String,
      default: () => ""
    },
    lightTitle: {
      type: Boolean,
      default: () => false
    },
    items: {
      type: Array,
      default: () => []
    },
    perPageCustom: {
      type: Array,
      default: () => [
        [200, 1],
        [768, 1],
        [992, 2],
        [1300, 2]
      ]
    }
  },
  mounted() {
    setTimeout(() => {
      let slides = document.getElementsByClassName("VueCarousel-dot");
      slides.forEach((item, index) => {
        slides[index].removeAttribute("title");
      });
    }, 200);
  }
};
</script>
<style lang="scss" scoped>
.promo-materials-carousel {
  ::v-deep .VueCarousel {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  ::v-deep .VueCarousel-pagination {
    bottom: -41px;
    position: absolute;
  }

  ::v-deep .VueCarousel-dot {
    border-radius: 0px;
    height: 2px !important;
    width: 20px !important;
    background-color: #c4c4c4 !important;

    &.VueCarousel-dot--active {
      background-color: #9155ec !important;
      width: 30px !important;
    }
  }

  ::v-deep .VueCarousel-dot:focus {
    outline: none;
  }

  ::v-deep .VueCarousel-navigation-next {
    transform: translateX(100%);
    text-align: left;
    margin-right: 25px;
    margin-top: -12.5% !important;
    font-size: 20px;

    @media screen and (max-width: 768px) {
      margin-top: -31% !important;
    }
  }

  ::v-deep .VueCarousel-navigation-prev {
    transform: translateX(100%);
    text-align: left;
    margin-left: 91.5%;
    margin-top: -12.5% !important;
    font-size: 20px;

    @media screen and (max-width: 768px) {
      margin-top: -31% !important;
      margin-left: 80%;
    }
  }

  ::v-deep .VueCarousel-navigation-prev:focus {
    outline: none;
  }

  ::v-deep .VueCarousel-navigation-next:focus {
    outline: none;
  }

  .light-text {
    font-weight: 500;
  }
}
</style>
